import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=66a2952e&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=ts"
export * from "./IconButton.vue?vue&type=script&lang=ts"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=66a2952e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../Lasso.LassoDK/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a2952e",
  null
  
)

export default component.exports